<template>
    <div>
    </div>
</template>
<script>
    export default {}
</script>


// WEBPACK FOOTER //
// src/components/homes/home.vue